import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {ExtraCurricularType} from '../types/ExtraCurricularType';

export const useGetExtraCurricular = () => {
  const [extraCurricular, setExtraCurricular] = useState<ExtraCurricularType[]>([]);
  const [extraCurricularLoading, setExtraCurricularLoading] = useState<boolean>(false);

  const getExtraCurricular = async () => {
    setExtraCurricularLoading(true);

    try {
      const response = await axios.get(URLS.GET_EXTRA_CURRICULAR_LOCAL);
      setExtraCurricular(response.data.extra_curricular);
    } catch (error) {
      console.error(error);
    } finally {
      setExtraCurricularLoading(false);
    }
  };

  useEffect(() => {
    getExtraCurricular();
  }, []);

  return {extraCurricularLoading, extraCurricular};
};
